var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',{staticClass:"dashboard"},[(_vm.role === 'candidate')?_c('CandidateDashboard'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }